import React from "react";
import { Link } from "react-router-dom";

import styled from "styled-components/macro";

import unoPiggyBank from "Payments/FundItPage/images/uno-piggy-bank.png";
import Blurb from "Signups/SharedComponents/MarketingBlurb";

import FnrButton from "UI/FnrButton3/FnrButton";

export default function FundItMarketingBlurb() {
  function goToFundItPage() {
    window.fnReactBus.goToUrl("/fundit");
  }

  return (
    <Blurb.Container>
      <Blurb.Title>
        <ResponsiveImage style={{ width: "20px" }}>
          <img src={unoPiggyBank} alt="piggy bank uno icon" />
        </ResponsiveImage>
        <h2>Invite Members to Set Up Online Giving</h2>
      </Blurb.Title>

      <p>
        {`Secure payment-processing is included with all Flocknote plans! Your members can seamlessly set up recurring online giving (in just a few clicks!) as part of the registration process. Simply verify your church's info, and tell us where to deposit the funds. `}
      </p>
      <p>
        <FnrButton size="small" color="green" onClick={goToFundItPage}>
          Learn More
        </FnrButton>
      </p>
    </Blurb.Container>
  );
}

const ResponsiveImage = styled.div`
  width: 20px;

  > img {
    width: 100%;
  }
`;
